export default __webpack_public_path__ + "static/media/fixrock-rockwool-komposition_comp.80c16c33.jpg";